import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UserDataService } from '../../services/user-data.service';

@Component({
  selector: 'app-landing-page',
  imports: [TranslatePipe],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent {

  constructor(private router: Router,
    public translate: TranslateService,
    private userDataService: UserDataService,
  ) {}

  goToLogin() {
    this.userDataService.checkUser().subscribe({
      next: user => {
        if (!!(user?.emailActivationTermDate)) {
          this.router.navigate(['/feedback']);
        } else {
          this.router.navigate(['/products']);
        }
      },
      error: _ => {
        this.router.navigate(['/login']);
      }
    })
  }
}
